import RiskSummary from './RiskSummary';
import ForecastGrossInvReturns from './ForecastGrossInvReturns';
import PortfolioSplit from './PortfolioSplit';
import PastPerformance from './PastPerformance';
import PolicyCharges from './PolicyCharges';
import RiskScore from './RiskScore';
import AggregateCostAndCharges from './AggregateCostAndCharges';

export default {
  RiskSummary,
  ForecastGrossInvReturns,
  PortfolioSplit,
  PastPerformance,
  PolicyCharges,
  RiskScore,
  AggregateCostAndCharges
};
